import { Statistic } from "antd";
import moment from "moment";
import { Component } from "react";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { withErrorBoundary } from "commonComponents/helpers/ErrorBoundary/ErrorBoundary";
import { DateDisplay } from "commonComponents/utilities/DateDisplay/DateDisplay";

import { type IBannerAlertProps } from "../HeaderAlerter.types";

interface IMaintenanceBannerState {
    isCountdownVisible: boolean;
}

class MaintenanceBannerInternal extends Component<IBannerAlertProps, IMaintenanceBannerState> {
    interval: number;
    state: IMaintenanceBannerState = {
        isCountdownVisible: moment().isAfter(
            moment(this.props.alert.extraData!.alertDate).subtract(10, "minutes"),
        ),
    };

    componentDidMount() {
        const IsComponentInitialMountUnder10Minutes = moment().isAfter(
            moment.utc(this.props.alert.extraData!.alertDate).subtract(10, "minutes"),
        );
        this.setState({
            isCountdownVisible: IsComponentInitialMountUnder10Minutes,
        });

        this.interval = setInterval(() => {
            const updateInLessThan10Minutes = moment().isAfter(
                moment.utc(this.props.alert.extraData!.alertDate).subtract(10, "minutes"),
            );
            if (updateInLessThan10Minutes !== this.state.isCountdownVisible) {
                this.setState({
                    isCountdownVisible: updateInLessThan10Minutes,
                });
            }
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const alert = this.props.alert;
        const alertTitle = "Buildertrend will be undergoing maintenance";
        const alertDateTime = moment.utc(alert.extraData!.alertDate);
        const alertStartDate = <DateDisplay value={alertDateTime} showDayOfWeek={true} />;
        const alertStartTime = (
            <DateDisplay value={alertDateTime} showTime={true} showDate={false} />
        );
        const alertBody = (
            <BTRow align="middle" gutter={16}>
                <BTCol>
                    The site will be inaccessible beginning on {alertStartDate} at {alertStartTime}.{" "}
                    Please save your work before this time.
                </BTCol>
                <BTCol>
                    {this.state.isCountdownVisible && (
                        <Statistic.Countdown
                            className="padding-bottom-xs"
                            value={alertDateTime.toISOString()}
                            format="mm [minutes] ss [seconds]"
                        />
                    )}
                </BTCol>
            </BTRow>
        );

        return (
            <BTAlert
                title={alertTitle}
                message={alertBody}
                type="warning"
                closable={false}
                data-testid="maintenanceWarning"
                banner
            />
        );
    }
}

const MaintenanceBanner = withErrorBoundary(MaintenanceBannerInternal)(
    "Could not load Maintenance Banner",
);

export default MaintenanceBanner;
